import { AnimaliaListItem } from '../entities/AnimaliaListItem';
import { AnimaliaListingResult } from '../entities/AnimaliaListingResult';

export const ANIMALIA_LIST_FILTER_KEYS = [
  'kingdom',
  'phylum',
  'class',
  'order',
  'family',
  'genus',
  'species',
] as const;

export type AnimaliaTaxonomyFilterKey = (typeof ANIMALIA_LIST_FILTER_KEYS)[number];

export type AnimaliaListFilters = Partial<Record<AnimaliaTaxonomyFilterKey, string>>;

export interface AnimaliaListRepositoryPort {
  fetchList(
    filters: AnimaliaListFilters | undefined,
    executedIds: ReadonlyArray<string>,
  ): Promise<AnimaliaListingResult>;
}
